// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2OVIZ","rootCenter":"LoadMoreObserver_rootCenter__3N_Qt","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2TRCL"};